/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import { fetchJSON } from '../../support/Fetch';

import { Icon, Text } from '../uiold';
import { themeColors } from '../uiold/Constants';

import ChangePassword from './ChangePassword';
import ForgotPassword from './ForgotPassword';
import LoginModal from './LoginModal';
import PasswordModal from './PasswordModal';
import RegistrationModal from './RegistrationModal';
import SideNavProfile from './SideNavProfile';
import SideNavLogin from './SideNavLogin';

import DataStore from '../../support/DataStore';

import { VendorPortalPage } from '../../types/shared/VendorPortalPage';
import { VendorAccount } from '../../types/shared/VendorAccount';

type Props = {
  marketName: string;
  marketAccountID: string;
  vendorAccount: VendorAccount | null | undefined;
  toggleMyInfo: (value: boolean) => void;
  toggleHomePage: (value: boolean) => void;
  displayLoginModal: boolean;
  displayHomepage: boolean;
  displayMyInfo: boolean;
  toggleLoginModal: (value: boolean) => void;
  onLoginSuccess: (
    vendorAccount: VendorAccount,
    billingLink: string | undefined,
  ) => void;
  registrationEmail?: string;
  showRegistrationModal: boolean;
  toggleRegistrationModal: (value: boolean) => void;
  changeSelectedVendorPortalPage: (vendorPortalPage: VendorPortalPage) => void;
  selectedVendorPortalPage: VendorPortalPage | null | undefined;
  email: string;
  billingLink: string | undefined;
  setEmail: (value: string) => void;
};

const dataStore = DataStore.getInstance('app');

export default function SideNav(props: Props) {
  const [vendorPortalPages, setVendorPortalPages] = useState<
    Array<VendorPortalPage>
  >([]);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const {
    changeSelectedVendorPortalPage,
    displayHomepage,
    displayLoginModal,
    displayMyInfo,
    email,
    billingLink,
    marketAccountID,
    marketName,
    registrationEmail,
    selectedVendorPortalPage,
    setEmail,
    showRegistrationModal,
    toggleHomePage,
    toggleLoginModal,
    onLoginSuccess,
    toggleMyInfo,
    toggleRegistrationModal,
    vendorAccount,
  } = props;

  function onLogout() {
    dataStore.set('vendorAccount', null);
    dataStore.clearAll();
    toggleHomePage(true);
  }

  useEffect(() => {
    fetchJSON(
      `/api/vendor-portal-pages/${marketAccountID}/${
        vendorAccount ? 'all' : 'public'
      }`,
    ).then((data) => {
      setVendorPortalPages(data.pages);
      // should we set a loading indicator?
    });
  }, [marketAccountID, vendorAccount]);

  const renderChangePasswordModal = () => {
    if (!showChangePasswordModal) {
      return;
    }
    return <ChangePassword onHide={() => setShowChangePasswordModal(false)} />;
  };

  const renderForgotModal = () => {
    if (!showForgotModal) {
      return;
    }
    return (
      <ForgotPassword
        marketName={marketName}
        marketAccountID={marketAccountID}
        onHide={() => setShowForgotModal(false)}
        onLoginSuccess={onLoginSuccess}
      />
    );
  };

  const renderLoginModal = () => {
    if (!displayLoginModal) {
      return;
    }
    return (
      <LoginModal
        email={email}
        marketAccountID={marketAccountID}
        setEmail={setEmail}
        displayRegistrationModal={() => toggleRegistrationModal(true)}
        displayPasswordModal={() => setShowPasswordModal(true)}
        onHide={() => toggleLoginModal(false)}
      />
    );
  };

  const renderRegistrationModal = () => {
    if (!showRegistrationModal) {
      return;
    }
    return (
      <RegistrationModal
        email={email}
        marketName={marketName}
        marketAccountID={marketAccountID}
        onLoginSuccess={onLoginSuccess}
        onHide={() => {
          toggleRegistrationModal(false);
        }}
      />
    );
  };

  const renderPasswordModal = () => {
    if (!showPasswordModal) {
      return;
    }
    return (
      <PasswordModal
        email={email}
        marketAccountID={marketAccountID}
        onLoginSuccess={onLoginSuccess}
        displayResetModal={() => {
          setShowPasswordModal(false);
          setShowForgotModal(true);
        }}
        onHide={() => setShowPasswordModal(false)}
        setEmail={setEmail}
      />
    );
  };

  return (
    <>
      <VendorPortalPageList
        toggleHomePage={toggleHomePage}
        marketName={marketName}
        vendorAccount={vendorAccount}
        toggleMyInfo={toggleMyInfo}
        displayHomepage={displayHomepage}
        displayMyInfo={displayMyInfo}
        toggleLoginModal={toggleLoginModal}
        registrationEmail={registrationEmail}
        showRegistrationModal={showRegistrationModal}
        toggleRegistrationModal={toggleRegistrationModal}
        changeSelectedVendorPortalPage={changeSelectedVendorPortalPage}
        selectedVendorPortalPage={selectedVendorPortalPage}
        vendorPortalPages={vendorPortalPages}
      />
      {renderChangePasswordModal()}
      {renderLoginModal()}
      {renderForgotModal()}
      {renderRegistrationModal()}
      {renderPasswordModal()}
      <View style={styles.options}>
        {vendorAccount ? (
          <SideNavProfile
            vendorAccount={vendorAccount}
            billingLink={billingLink}
            onLogoutPress={onLogout}
            onChangePasswordPress={() => setShowChangePasswordModal(true)}
          />
        ) : (
          <SideNavLogin onPress={() => toggleLoginModal(true)} />
        )}
      </View>
    </>
  );
}

function VendorPortalPageList(props: {
  marketName: string;
  vendorAccount: VendorAccount | null | undefined;
  toggleMyInfo: (value: boolean) => void;
  displayHomepage: boolean;
  displayMyInfo: boolean;
  toggleLoginModal: (value: boolean) => void;
  registrationEmail?: string;
  showRegistrationModal: boolean;
  toggleRegistrationModal: (value: boolean) => void;
  changeSelectedVendorPortalPage: (vendorPortalPage: VendorPortalPage) => void;
  selectedVendorPortalPage: VendorPortalPage | null | undefined;
  vendorPortalPages: Array<VendorPortalPage> | undefined;
  toggleHomePage: (value: boolean) => void;
}) {
  let {
    vendorPortalPages,
    toggleMyInfo,
    displayMyInfo,
    vendorAccount,
    selectedVendorPortalPage,
    displayHomepage,
    toggleHomePage,
    changeSelectedVendorPortalPage,
  } = props;
  let listItems =
    vendorPortalPages?.map((page) => {
      return (
        <TouchableOpacity
          activeOpacity={0.6}
          key={page.id}
          onPress={() => {
            changeSelectedVendorPortalPage(page);
          }}
          style={[
            styles.listItem,
            selectedVendorPortalPage &&
              page.id === selectedVendorPortalPage.id &&
              styles.selectedListItem,
          ]}
        >
          <View style={styles.itemText}>
            <Text
              type="label"
              style={[
                styles.itemTitle,
                selectedVendorPortalPage &&
                page.id === selectedVendorPortalPage.id
                  ? styles.itemTitleSelected
                  : styles.itemTitleUnselected,
              ]}
              numberOfLines={2}
            >
              {page.title}
            </Text>
          </View>
          {selectedVendorPortalPage && page.id === selectedVendorPortalPage.id && (
            <View style={styles.itemIcon}>
              <Icon
                name="chevronDown"
                size="XS"
                color={themeColors.marketNavBackground}
                style={{ transform: [{ rotate: '-90deg' }] }}
              />
            </View>
          )}
        </TouchableOpacity>
      );
    }) ?? [];
  if (vendorAccount) {
    return (
      <View style={styles.list}>
        <TouchableOpacity
          activeOpacity={0.6}
          key="my-profile-page"
          onPress={() => {
            toggleMyInfo(true);
          }}
          style={[styles.listItem, displayMyInfo && styles.selectedListItem]}
        >
          <View style={styles.itemText}>
            <Text
              type="label"
              style={[
                styles.itemTitle,
                displayMyInfo
                  ? styles.itemTitleSelected
                  : styles.itemTitleUnselected,
              ]}
              numberOfLines={2}
            >
              My Profile
            </Text>
          </View>
          {displayMyInfo && (
            <View style={styles.itemIcon}>
              <Icon
                name="chevronDown"
                size="XS"
                color={themeColors.marketNavBackground}
                style={{ transform: [{ rotate: '-90deg' }] }}
              />
            </View>
          )}
        </TouchableOpacity>
        {listItems}
      </View>
    );
  }
  return (
    <View style={styles.list}>
      <TouchableOpacity
        activeOpacity={0.6}
        key="home-page"
        onPress={() => {
          toggleHomePage(true);
        }}
        style={[styles.listItem, displayHomepage && styles.selectedListItem]}
      >
        <View style={styles.itemText}>
          <Text
            type="label"
            style={[
              styles.itemTitle,
              displayHomepage
                ? styles.itemTitleSelected
                : styles.itemTitleUnselected,
            ]}
            numberOfLines={2}
          >
            Home
          </Text>
        </View>
        {displayHomepage && (
          <View style={styles.itemIcon}>
            <Icon
              name="chevronDown"
              size="XS"
              color={themeColors.marketNavBackground}
              style={{ transform: [{ rotate: '-90deg' }] }}
            />
          </View>
        )}
      </TouchableOpacity>
      {listItems}
    </View>
  );
}

let styles = StyleSheet.create({
  list: {
    flex: 1,
    overflowY: 'auto',
  },
  listItem: {
    minHeight: 56,
    padding: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  selectedListItem: {
    backgroundColor: themeColors.withOpacity.blue8,
    borderLeftWidth: StyleSheet.hairlineWidth * 6,
    borderColor: themeColors.blue,
  },
  itemText: {
    justifyContent: 'center',
  },
  itemTitle: {
    fontWeight: '600',
    marginBottom: 6,
  },
  itemTitleSelected: {
    color: themeColors.black,
  },
  itemTitleUnselected: {
    color: themeColors.darkGrey,
  },
  itemIcon: {
    justifyContent: 'center',
  },
  options: {
    borderTopWidth: 1,
    borderColor: themeColors.borderGrey,
    paddingVertical: 12,
    paddingHorizontal: 9,
  },
});
